import React, { Component } from 'react';
import {Row, Col, Container} from '../3rdparty/react-pure-grid';
import Session from '../services/session';
import i from '../imports';

const notTranslated = 'Not translated'

class Card extends Component {

    render() {
        // console.log(this.props.children);
        return (
            <Col xs={12} md={12}>
                <Row>
                    <Col style={{ lineHeight: 0.9, fontSize: 20, marginBottom: 10, marginTop:20, height: 40}}>
                        {this.props.title}
                    </Col>
                </Row>
            <i.NavLink to={this.props.url} style={{color: "black"}}>
                <div style={{marinBottom: 10, position: 'relative', height: 200, backgroundImage: `url('${this.props.background}')`, backgroundSize: 'cover'}} className='card'>
                    <div style={{ position: 'absolute', bottom: 0, left:0, right: 0, height: 70, width: '100%', display: 'table', backgroundColor: 'rgba(255, 255, 255, 0.753)', borderRadius: '0 0 10px 10px', paddingLeft:'2px'}}>
                        <span style={{fontSize: 16, verticalAlign: 'middle', display: 'table-cell'}}>
                            {this.props.children}
                            {this.props.priceFrom ? 
                                <div style={{textAlign: "right", color: "#FF5563", fontSize: 15, paddingRight: 25, paddingTop: 10, paddingBottom: 5, fontWeight: "bold"}}>
                                    {Session.model.common.words.price_from} {Number(this.props.priceFrom).toLocaleString("ru-RU")} <span style={{textTransform: "uppercase"}}>{Session.model.common.words.rub}</span>
                                </div>
                            : null}                            
                        </span>
                    </div>
                </div>
            </i.NavLink>
            </Col>
        );
    }
}

class CardsList extends Component {

    render() {

        const items = this.props.items;
        // console.log(items);

        return (
            <Container>
                <Row align={'end'} >
                    {items.map( (item, index) => {
                        let url = i.Utils.locUrl(this.props.urlBuilder ? this.props.urlBuilder(item) : "");
                        return <Col xs={12} md={4}><Card style={{marginTop: 10}} key={index}
                            title={item.translations[0] ? item.translations[0].title : notTranslated}
                            url={url}
                            priceFrom={item.price}
                            background={item.pic}>{item.translations[0] ? item.translations[0].short_text : notTranslated}</Card></Col>
                    })}
                </Row>
            </Container>
        );
    }
}

export {
    Card,
    CardsList
};